import axios from 'axios';

export const usersClientsMarcasApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/users-clients-marcas`,
    headers: {
        'Content-Type': 'application/json'
    }
})